import {useEffect, useReducer} from 'react';

import {getActiveState} from 'client/framework';

/**
 * Re-renders the calling component whenever the legacy framework store emits 'change'.
 *
 * Remaining use: the class-detail chrome boundary (ClassroomsChromeWrapper), where it re-clones
 * LEGACY tab subtrees so their passive Mandark reads re-run — restoring the app's old top-down
 * cascade for uncompiled legacy components. Do NOT use it from React-Compiler-compiled code
 * (see webpack.config.js REACT_COMPILER_DIRS): a compiled component memoizes its render-time
 * reads, so the pump's re-render can't reach them — bridge each read with `useFluxStore`
 * (client/framework) instead. Delete once the legacy tabs are bridged or on GQL.
 */
export const useStoreChangePump = (): void => {
  const [, rerender] = useReducer((tick: number) => tick + 1, 0);
  useEffect(() => {
    const state = getActiveState();
    state.on('change', rerender);
    return () => {
      state.removeListener('change', rerender);
    };
  }, []);
};
